import classNames from 'classnames';
import {CartStep, useCartContext} from 'modules/Cart/contexts/cartContext';
import {FC, useCallback} from 'react';

import {Icon} from 'components/Icon/Icon';
import {Text} from 'components/Text/Text';

import styles from './CartHeader.module.css';

type Props = {
    className?: string;
};
export const CartHeader: FC<Props> = ({className}) => {
    const {step, setStep} = useCartContext();

    const handleBack = useCallback(() => {
        window.history.back();
    }, []);

    return (
        <div className={classNames(styles.block, className)}>
            <div className={styles.stepsContainer}>
                <div className={styles.steps}>
                    <div
                        className={classNames(styles.step, {
                            [styles.active]: step === CartStep.Products,
                        })}
                        onClick={() => setStep(CartStep.Products)}
                    >
                        <Text.Bold14 className={styles.number}>1</Text.Bold14>
                        <Text.Responsive
                            breakpointsMap={{default: 'Bold24', sm: 'Bold30'}}
                        >
                            Корзина
                        </Text.Responsive>
                    </div>
                    <div
                        className={classNames(styles.step, {
                            [styles.active]: step === CartStep.Order,
                        })}
                        onClick={() => setStep(CartStep.Order)}
                    >
                        <Text.Bold14 className={styles.number}>2</Text.Bold14>
                        <Text.Responsive
                            breakpointsMap={{default: 'Bold24', sm: 'Bold30'}}
                        >
                            Оформление заказа
                        </Text.Responsive>
                    </div>
                </div>
            </div>
            <div className={styles.back} onClick={handleBack}>
                <Icon name="back" className={styles.backIcon} />
                <Text.Semibold12>Вернуться к покупкам</Text.Semibold12>
            </div>
        </div>
    );
};
